import JitsiMeetJS, { AudioMixer, IStreamEffect, JitsiLocalTrack } from 'lib-jitsi-meet'

import { AUDIO_DEVICE } from '@tabeeb/modules/presentation/constants'

export class AudioMixerEffect implements IStreamEffect {
  _mixAudio: JitsiLocalTrack

  _audioMixer?: AudioMixer

  _originalStream?: MediaStream

  _mixedMediaStream?: MediaStream

  _originalTrack?: MediaStreamTrack | undefined

  _mixedMediaTrack?: MediaStreamTrack | undefined

  constructor(mixAudio: JitsiLocalTrack) {
    if (mixAudio.getType() !== AUDIO_DEVICE) {
      throw new Error('AudioMixerEffect only supports audio JitsiLocalTracks; effect will not work!')
    }

    this._mixAudio = mixAudio
  }

  isEnabled(sourceLocalTrack: JitsiLocalTrack) {
    return sourceLocalTrack.isAudioTrack() && this._mixAudio.isAudioTrack()
  }

  startEffect(audioStream: MediaStream) {
    this._originalStream = audioStream
    this._originalTrack = audioStream.getTracks().at(0)

    this._audioMixer = JitsiMeetJS.createAudioMixer()
    this._audioMixer.addMediaStream(this._mixAudio.getOriginalStream())
    this._audioMixer.addMediaStream(this._originalStream)

    this._mixedMediaStream = this._audioMixer.start()!
    this._mixedMediaTrack = this._mixedMediaStream.getTracks().at(0)

    return this._mixedMediaStream
  }

  stopEffect() {
    this._audioMixer?.reset()
  }

  setMuted(muted: boolean) {
    if (!this._originalTrack) {
      return
    }

    this._originalTrack.enabled = !muted
  }

  isMuted() {
    return !this._originalTrack?.enabled
  }
}
